export const getStartingList = (state: any): any => state.startingList
